import ComingSoonCluster from "../../components/ComingSoonCluster/ComingSoonCluster";

const ComingSoonPage = () => {
  return (
    <ComingSoonCluster title="Coming Soon!" light={false} />
  );
}; 

// const ComingSoonCluster= (title, list =[]) => {
//   return (
//     <div className="bg-dark flex-column-centered" style={{height:"100vh"}} >
//       <BoldText clr="clr-dark-red" marginClass={"margin-bottom-5"} class_Name="font-size-6" > Links</BoldText>
//       <div className="flex-column-centered" style={{width:"85%"}} >
//         <DirectoryButton title="Website" iconClass="fa-solid fa-laptop" light={false} />
//         <DirectoryButton title="Website" iconClass="fa-solid fa-laptop" light={false} />
//         <DirectoryButton title="Website" iconClass="fa-solid fa-laptop" light={false} />
//       </div>
//     </div>
//   );
// }; 


export default ComingSoonPage;